import { render, staticRenderFns } from "./TreatmentPlagueCard.vue?vue&type=template&id=0947a99d&"
import script from "./TreatmentPlagueCard.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlagueCard.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentPlagueCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports